import {
  Image as ImageIcon,
  Users,
  FileText,
  Briefcase,
  Settings,
  Theater,
  Ticket,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface AdminNavChild {
  to: string
  label: string
  description?: string
  end?: boolean
}

export interface AdminNavItem {
  to: string
  label: string
  icon: LucideIcon
  end?: boolean
  children?: AdminNavChild[]
}

export const adminNavItems: AdminNavItem[] = [
  {
    to: '/admin/community',
    label: 'Community',
    icon: Users,
    children: [
      { to: '/admin/mailing-list', label: 'Mailing List', description: 'Newsletter subscribers & segments' },
      { to: '/admin/testimonials', label: 'Testimonials', description: 'Client testimonials & survey responses' },
    ],
  },
  {
    to: '/admin/applications',
    label: 'Applications',
    icon: FileText,
    children: [
      { to: '/admin/applications/dashboard', label: 'Dashboard',        description: 'Submission trends and review queue overview' },
      { to: '/admin/applications',     label: 'All Applications', description: 'Manage application listings and forms', end: true },
      { to: '/admin/field-library',    label: 'Field Library',    description: 'Reusable question bank for forms'      },
      { to: '/admin/section-library',  label: 'Section Library',  description: 'Reusable form section templates'       },
    ],
  },
  {
    to: '/admin/productions',
    label: 'Productions',
    icon: Theater,
    end: true,
  },
  {
    to: '/admin/events',
    label: 'Events & Tickets',
    icon: Ticket,
  },
  {
    to: '/admin/client-services',
    label: 'Client Services',
    icon: Briefcase,
    children: [
      { to: '/admin/client-services/dashboard',   label: 'Dashboard',          description: 'Request trends and pipeline overview' },
      { to: '/admin/client-services/requests',    label: 'Service Requests',   description: 'View and manage incoming requests'    },
      { to: '/admin/client-services/engagements', label: 'Client Engagements', description: 'Client service records & files'       },
      { to: '/admin/client-services/clients',     label: 'Clients',            description: 'Client roster with revenue & activity metrics' },
      { to: '/admin/client-services/board',       label: 'Project Board',      description: 'Kanban-style task management'         },
      { to: '/admin/client-services/personnel',   label: 'Personnel',          description: 'Team member management'               },
      { to: '/admin/client-services/invoices',    label: 'Invoices',           description: 'Contractor invoice tracking'          },
      { to: '/admin/client-services/inventory',   label: 'Tech Inventory',     description: 'Equipment and asset tracking'         },
    ],
  },
  {
    to: '/admin/config',
    label: 'Config',
    icon: Settings,
    children: [
      { to: '/admin/config/company',    label: 'Company',          description: 'Manage team members & positions'       },
      { to: '/admin/config/home-hero',  label: 'Home Hero Banner', description: 'Configurable banner at the top of the home page' },
      { to: '/admin/config/seasons',    label: 'Seasons',          description: 'Manage seasons'                        },
      { to: '/admin/config/films',      label: 'Films',            description: 'Manage season episodes'                },
      { to: '/admin/config/projects',   label: 'Projects',         description: 'Manage client work & one-off films'    },
      { to: '/admin/config/services',   label: 'Services',         description: 'Manage service offerings'              },
      { to: '/admin/config/board-templates', label: 'Board Templates', description: 'Reusable kanban layouts per service' },
      { to: '/admin/config/stripe', label: 'Stripe Billing', description: 'Connected account readiness and onboarding' },
      { to: '/admin/config/festivals',  label: 'Festivals',        description: 'Manage festivals & editions'           },
      { to: '/admin/shop',              label: 'Shop',             description: 'Sync Printify products'                },
      { to: '/admin/config/user-links', label: 'User Links',       description: 'Member-account linking'                },
      { to: '/admin/config/terms',      label: 'Terms of Service', description: 'Edit public terms of service sections' },
      { to: '/admin/config/press-kit',  label: 'Press Kit',        description: 'Manage press kit content & assets'     },
    ],
  },
  { to: '/admin/media', label: 'Media', icon: ImageIcon, end: true },
  {
    to: '/admin/ui',
    label: 'Development',
    icon: Wrench,
    children: [
      { to: '/admin/ui',              label: 'UI Library',      description: 'Component showcase & design tokens' },
      { to: '/admin/email-templates', label: 'Email Templates', description: 'Preview all transactional emails + send tests' },
    ],
  },
]
